import React from "react";
import { advanceNumericEntry } from "../../utils/advanceNumericEntry";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { formatDateForStorage, parseLocalDate, formatDateForDisplay } from "../../utils/dateUtils";

function EditableTableRow({
  label,
  value,
  name,
  onChange,
  isEditMode,
  isDate = false,
  isDropdown = false,
  options = [],
  dateFormat = "MM/dd/yyyy",
  isLeader = false,
  leaderId = '',
  editLink = '',
  disabled = false,
  advanceOnEnter = false
}) {
  // Custom onChange handler for DatePicker to standardize the event structure
  const handleDateChange = (date) => {
    // Format the date as YYYY-MM-DD to avoid timezone issues
    const formattedDate = formatDateForStorage(date);
    onChange({ target: { name, value: formattedDate } });
  };

  const handleDropdownChange = (event) => {
    const { name, value } = event.target;
    const selectedOption = options.find(option => option.employee_full_name === value);

    // Check if "Choose" is selected, then set the idValue to null
    const idValue = selectedOption ? selectedOption.id : null;

    onChange({
      target: {
        name,
        value: value === 'Choose' ? null : value,  // Set the actual value to null if "Choose" is selected
        idKey: name + "_Id",
        idValue: idValue  // This will be null if "Choose" is selected or if no matching option is found
      }
    });
  };

  // Handle date formatting for display
  const formatDate = (dateString) => {
    const formatted = formatDateForDisplay(dateString);
    return formatted || "No data";
  };

  if (isLeader && isEditMode) {
    return (
      <>
        <tr>
          <td style={{ textAlign: "left" }}>{label}:</td>
          <td style={{ textAlign: "right" }}>
            <input
              type="text"
              name={name}
              value={value || ''}
              onChange={onChange}
              placeholder={`Enter ${label}`}
              disabled={disabled}
              style={disabled ? { backgroundColor: '#f0f0f0', cursor: 'not-allowed' } : {}}
            />
          </td>
        </tr>
        {leaderId && (
          <tr>
            <td>Edit:</td>
            <td><a href={editLink}>Edit {label}</a></td>
          </tr>
        )}
      </>
    );
  }

  // Handling for non-leader fields or non-edit mode
  return (
    <tr>
      <td style={{ textAlign: "left" }}>{label}:</td>
      <td style={{ textAlign: "right", fontWeight: "bold" }}>
        {isEditMode ? (
          isDate ? (
            <DatePicker
              selected={parseLocalDate(value)}
              onChange={handleDateChange}
              dateFormat={dateFormat}
              name={name}
              wrapperClassName="datePicker"
              disabled={disabled}
              withPortal
              portalId="datepicker-portal"
              todayButton="Today"
            />
          ) : isDropdown ? (
            <select name={name} value={value} onChange={handleDropdownChange} disabled={disabled} style={disabled ? { backgroundColor: '#f0f0f0', cursor: 'not-allowed' } : {}}>
              <option value="">Choose...</option>
              {options.map(option => (
                <option key={option.id} value={option.employee_full_name}>
                  {option.employee_full_name}
                </option>
              ))}
            </select>
          ) : (
            <input type="text" name={name} aria-label={label} value={value} onChange={onChange} disabled={disabled} data-numeric-entry={advanceOnEnter ? "true" : undefined} inputMode={advanceOnEnter ? "numeric" : undefined} onKeyDown={advanceOnEnter ? advanceNumericEntry : undefined} style={disabled ? { backgroundColor: '#f0f0f0', cursor: 'not-allowed' } : {}} />
          )
        ) : (
          isDate ? formatDate(value) : (value || 'No data')
        )}
      </td>
    </tr>
  );
}

export default EditableTableRow;
